import { getPresentationInterval } from "Areas/SharedFeatures/downSidePanel/redux/selectors";
import documentsSidebarMenuActionCreators from "Areas/Sidebar/Documents/redux/actionCreators";
import { getDocumentsInProgress, getNavigateToId, getObjects, getObjectsInProgress, getSourceTaskIdsToHighlight } from "Areas/Sidebar/Documents/redux/selectors";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { Permissions, security } from "Common/permissions";
import withPopupMessage from "Components/withPopupMessage";
import filter from "lodash/filter";
import find from "lodash/find";
import flatMap from "lodash/flatMap";
import forEach from "lodash/forEach";
import head from "lodash/head";
import includes from "lodash/includes";
import keyBy from "lodash/keyBy";
import map from "lodash/map";
import values from "lodash/values";
import { connect } from "react-redux";
import documentDetailsActionCreators from "../documentDetails/redux/actionCreators";
import { getFinalReadOnlyMode } from "../documentDetails/redux/getReadOnlyMode";
import { getInnerObjectsSelectedIds } from "../documentDetails/redux/selectors";
import { READ_ONLY_MODE } from "../documentDetails/types/readOnlyMode";
import { redoSelector, undoSelector } from "./constants";
import Graph from "./graph";
import actionCreators from "./redux/actionCreators";
import { getActiveDocumentId, getEdgesSource, getGraphInstanceKey, getHasChanges, getInProgress, getLayoutAlgorithm, getNodesSource, getSaveInProgress, getSaveTriggered, getSelectedObjectsType, getSourceData, getSourceTaskIdsToHide, getSourceTaskIdsToShow, getUpdates } from "./redux/selectors";
import getGraphEdgeSources from "./utils/nodeOrEdgeSourceDataHandling/getGraphEdgeSources";
import nodeSourceFactory from "./utils/nodeOrEdgeSourceDataHandling/nodeSourceFactory";
import { updateGroupNodeTable } from "./utils/nodeRendering/updateGroupNodeTable";
const canEdit = security.isAllowed([Permissions.DocumentsEdit]);
const mapStateToProps = (state) => {
    var _a, _b, _c;
    const readOnlyMode = getFinalReadOnlyMode(state);
    const sourceData = getSourceData(state);
    const documentId = getActiveDocumentId(state);
    const selected = getInnerObjectsSelectedIds(state);
    return {
        key: documentId || "",
        sourceDataKey: getGraphInstanceKey(state),
        documentId,
        documentObjects: getObjects(state),
        inProgress: getInProgress(state) || getObjectsInProgress(state) || getDocumentsInProgress(state),
        saveGraphInProgress: getSaveInProgress(state),
        initialGraphModel: sourceData === null || sourceData === void 0 ? void 0 : sourceData.GraphModel,
        initialJSONGraphModel: {
            Nodes: (_a = sourceData === null || sourceData === void 0 ? void 0 : sourceData.Nodes) !== null && _a !== void 0 ? _a : [],
            Edges: (_b = sourceData === null || sourceData === void 0 ? void 0 : sourceData.Edges) !== null && _b !== void 0 ? _b : [],
            DataGroups: (_c = sourceData === null || sourceData === void 0 ? void 0 : sourceData.DataGroups) !== null && _c !== void 0 ? _c : []
        },
        initialNodesSource: readOnlyMode !== READ_ONLY_MODE.READ_WRITE ? sourceData === null || sourceData === void 0 ? void 0 : sourceData.NodesSource : getNodesSource(state),
        initialEdgesSource: readOnlyMode !== READ_ONLY_MODE.READ_WRITE ? sourceData === null || sourceData === void 0 ? void 0 : sourceData.EdgesSource : getEdgesSource(state),
        layoutAlgorithm: getLayoutAlgorithm(state),
        hasChanges: getHasChanges(state),
        sourceData,
        updates: getUpdates(state),
        navigateToId: getNavigateToId(state),
        undoSelector,
        redoSelector,
        saveTriggered: getSaveTriggered(state),
        sourceTaskIdsToShow: getSourceTaskIdsToShow(state),
        sourceTaskIdsToHide: getSourceTaskIdsToHide(state),
        selected,
        selectedObjectsType: getSelectedObjectsType(state),
        canEdit,
        presentationInterval: getPresentationInterval(state),
        readOnlyMode,
        sourceTaskIdsToHighlight: getSourceTaskIdsToHighlight(state)
    };
};
const getGraphGroupsNodes = (dispatch, documentId, graphComponentRef, nodes, nodeIdsPinnedOutOfGroup, completed, rejected) => {
    const nodeIds = new Set();
    const groupsPartialLoaded = new Set();
    forEach(nodes, item => {
        if (!item.tag)
            return;
        if (item.tag.NodeId)
            nodeIds.add(item.tag.NodeId);
        else if (item.tag.GroupId) {
            const groupNodes = item.tag.Nodes || [];
            const groupObjectCount = item.tag.GroupObjectCount || 0;
            forEach(groupNodes, n => {
                nodeIds.add(n.NodeId);
            });
            if (groupNodes.length < groupObjectCount)
                groupsPartialLoaded.add(item);
        }
    });
    if (groupsPartialLoaded.size) {
        dispatch(actionCreators.getGraphGroupsNodes(documentId, map(Array.from(groupsPartialLoaded), "tag.GroupId"), (nodeSource, edgesSource) => {
            var _a;
            if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.div.isConnected) || !graphComponentRef.current.graph)
                return;
            let updatedGroupsNodes = [];
            const updatedEdgeSources = [];
            groupsPartialLoaded.forEach(g => {
                var _a;
                if (!(g === null || g === void 0 ? void 0 : g.layout) || !(g === null || g === void 0 ? void 0 : g.tag) || !(g === null || g === void 0 ? void 0 : g.tag.GroupId) || !graphComponentRef.current)
                    return;
                const groupTag = g.tag;
                const groupLoadedNodes = {};
                const pinnedOutOfGroup = nodeIdsPinnedOutOfGroup[groupTag.GroupId] || [];
                forEach(filter(nodeSource, n => n.GroupId === groupTag.GroupId && !includes(pinnedOutOfGroup, n.NodeId)), e => {
                    const item = nodeSourceFactory(e, groupTag.DocumentObjects);
                    groupLoadedNodes[item.NodeId] = item;
                    nodeIds.add(item.NodeId);
                });
                const newGroupNodes = values({
                    ...groupLoadedNodes,
                    ...keyBy(groupTag.Nodes, "NodeId")
                });
                g.tag.Nodes = newGroupNodes;
                g.tag.Created = (_a = head(newGroupNodes)) === null || _a === void 0 ? void 0 : _a.Created;
                updateGroupNodeTable(g, newGroupNodes);
                const fromGroup = filter(edgesSource, ["FromGroup", groupTag.GroupId]);
                const toGroup = filter(edgesSource, ["ToGroup", groupTag.GroupId]);
                if (fromGroup.length || toGroup.length) {
                    const outGroupGroupedEdges = graphComponentRef.current.graph
                        .outEdgesAt(g)
                        .filter(e => { var _a; return Boolean((_a = e.tag) === null || _a === void 0 ? void 0 : _a.Edges); })
                        .toArray();
                    const inGroupGroupedEdges = graphComponentRef.current.graph
                        .inEdgesAt(g)
                        .filter(e => { var _a; return Boolean((_a = e.tag) === null || _a === void 0 ? void 0 : _a.Edges); })
                        .toArray();
                    if (outGroupGroupedEdges.length || inGroupGroupedEdges.length) {
                        forEach(fromGroup, item => {
                            const groupedEdge = find(outGroupGroupedEdges, e => {
                                var _a, _b;
                                if (!e.targetNode || !graphComponentRef.current)
                                    return false;
                                const isTargetNodeGroup = graphComponentRef.current.graph.isGroupNode(e.targetNode);
                                if (isTargetNodeGroup)
                                    return Boolean(item.ToGroup && ((_a = e.targetNode.tag) === null || _a === void 0 ? void 0 : _a.GroupId) === item.ToGroup);
                                return Boolean(item.To && ((_b = e.targetNode.tag) === null || _b === void 0 ? void 0 : _b.NodeId) === item.To);
                            });
                            if (groupedEdge) {
                                const prevTag = groupedEdge.tag;
                                prevTag.Edges = [...prevTag.Edges, { ...item, GroupId: prevTag.GroupId }];
                            }
                            else {
                                console.warn(`Parent edge for update was not founded for edge with EdgeId="${item.EdgeId}", From="${item.From}" and To="${item.To}", FromGroup="${item.FromGroup}" and ToGroup="${item.ToGroup}"`);
                            }
                        });
                        forEach(toGroup, item => {
                            const groupedEdge = find(inGroupGroupedEdges, e => {
                                var _a, _b;
                                if (!e.sourceNode || !graphComponentRef.current)
                                    return false;
                                const isSourceNodeGroup = graphComponentRef.current.graph.isGroupNode(e.sourceNode);
                                if (isSourceNodeGroup)
                                    return Boolean(item.FromGroup && ((_a = e.sourceNode.tag) === null || _a === void 0 ? void 0 : _a.GroupId) === item.FromGroup);
                                return Boolean(item.From && ((_b = e.sourceNode.tag) === null || _b === void 0 ? void 0 : _b.NodeId) === item.From);
                            });
                            if (groupedEdge) {
                                const prevTag = groupedEdge.tag;
                                prevTag.Edges = [...prevTag.Edges, { ...item, GroupId: prevTag.GroupId }];
                            }
                            else {
                                console.warn(`Parent edge for update was not founded for edge with EdgeId="${item.EdgeId}", From="${item.From}" and To="${item.To}", FromGroup="${item.FromGroup}" and ToGroup="${item.ToGroup}"`);
                            }
                        });
                    }
                }
                updatedGroupsNodes = updatedGroupsNodes.concat(newGroupNodes);
            });
            dispatch(actionCreators.setGraphModel(documentId, {
                nodesSource: updatedGroupsNodes,
                edgesSource: updatedEdgeSources,
                onlyDiffSources: true
            }, true, true, true));
            completed === null || completed === void 0 ? void 0 : completed(nodeIds);
        }, () => {
            rejected === null || rejected === void 0 ? void 0 : rejected(nodeIds);
        }));
    }
    else {
        completed === null || completed === void 0 ? void 0 : completed(nodeIds);
    }
};
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => {
        dispatch(documentsSidebarMenuActionCreators.getObjects());
        dispatch(documentsSidebarMenuActionCreators.setNavigateTo(undefined));
    },
    onGetGraphData: (documentId, onlyUpdates) => onlyUpdates
        ? dispatch(actionCreators.getDocumentGraphDataUpdates(documentId))
        : dispatch(actionCreators.getDocumentGraphData(documentId, () => {
            dispatch(actionCreators.getDocumentGraphDataUpdates(documentId));
        })),
    onSaveGraphData: (documentId, prevData, nodesSource, edgesSource, model, nodes, edges, dataGroups, appliedUpdates, groups, completed) => dispatch(actionCreators.saveDocumentGraphData({
        documentId,
        prevData,
        nodesSource,
        edgesSource,
        model,
        nodes,
        edges,
        dataGroups,
        appliedUpdates,
        groups,
        completed
    })),
    onChangeSelected: (documentId, graphComponentRef, selectedNodes, selectedEdges, nodeIdsPinnedOutOfGroup, completed, rejected) => {
        if (!selectedNodes.length && !selectedEdges.length) {
            dispatch(documentDetailsActionCreators.setInnerObjectsSelectedIds([], documentId, DOCUMENT_TYPE.GRAPH));
            completed === null || completed === void 0 ? void 0 : completed();
            return;
        }
        if (selectedNodes.length) {
            getGraphGroupsNodes(dispatch, documentId, graphComponentRef, selectedNodes, nodeIdsPinnedOutOfGroup, (nodeIds) => {
                dispatch(documentDetailsActionCreators.setInnerObjectsSelectedIds(Array.from(nodeIds), documentId, DOCUMENT_TYPE.GRAPH));
                completed === null || completed === void 0 ? void 0 : completed(nodeIds);
            }, (nodeIds) => {
                dispatch(documentDetailsActionCreators.setInnerObjectsSelectedIds(Array.from(nodeIds), documentId, DOCUMENT_TYPE.GRAPH));
                rejected === null || rejected === void 0 ? void 0 : rejected();
            });
        }
        else {
            const edgeIds = map(flatMap(selectedEdges, getGraphEdgeSources), "EdgeId");
            dispatch(documentDetailsActionCreators.setInnerObjectsSelectedIds(Array.from(edgeIds), documentId, DOCUMENT_TYPE.GRAPH));
            completed === null || completed === void 0 ? void 0 : completed();
        }
    },
    onGetGraphGroupsNodes: (documentId, graphComponentRef, groups, nodeIdsPinnedOutOfGroup, completed, rejected) => {
        getGraphGroupsNodes(dispatch, documentId, graphComponentRef, groups, nodeIdsPinnedOutOfGroup, completed, rejected);
    },
    onChangeGraphModel: (documentId, data, updateNodesSourceDocumentObjectId, updateSourceData) => dispatch(actionCreators.setGraphModel(documentId, data, true, updateSourceData, updateNodesSourceDocumentObjectId)),
    onChangeDetailedPanelOpen: (open) => dispatch(actionCreators.setDetailedPanelOpen(open)),
    onResetNavigateTo: () => dispatch(documentsSidebarMenuActionCreators.setNavigateTo(undefined)),
    onClearFromFromUpdates: (documentId, nodesSourceUpdateRecordIds, edgesSourceUpdateRecordIds) => dispatch(actionCreators.clearFromUpdates(documentId, nodesSourceUpdateRecordIds, edgesSourceUpdateRecordIds)),
    onShowResultsSourceTaskIds: (documentId, sourceTaskIds) => {
        dispatch(actionCreators.getSourceTasksResults(documentId, sourceTaskIds));
        dispatch(actionCreators.clearFromShowHideTaskResults(documentId, sourceTaskIds));
    },
    onHideResultsSourceTaskIds: (documentId, sourceTaskIds) => {
        dispatch(actionCreators.clearFromShowHideTaskResults(documentId, sourceTaskIds));
    },
    onGetPreview: (largeAttributeId, completed, rejected) => dispatch(documentDetailsActionCreators.getGraphNodeImageContent(largeAttributeId, completed, rejected)),
    onPasteGraphData: (data, completed, rejected) => dispatch(actionCreators.pasteDocumentGraphData(data, completed, rejected)),
    onSetHasChanges: (documentId, hasChanges) => dispatch(actionCreators.setHasChanges(documentId, hasChanges)),
    onSetLayoutAlgorithm: (documentId, layoutAlgorithm) => dispatch(actionCreators.setLayoutAlgorithm(documentId, layoutAlgorithm)),
    onOpenTableViewModal: (documentId, data) => {
        dispatch(actionCreators.setTableModalState(true));
        dispatch(actionCreators.setGroupTableData(documentId, data));
    },
    onClearSourceTaskIdsToHighlight: (documentId) => dispatch(documentsSidebarMenuActionCreators.clearSourceTaskIdsToHighlight(documentId))
});
export default connect(mapStateToProps, mapDispatchToProps)(withPopupMessage(Graph));
